import React from 'react';
import { dropdowns, layouts, switches } from 'seal-ui-components';
import guid from '@Utils/commonUtils';
import DropDownIconButtonWrapper from './DropDownIconButton.style';

const { CustomSelect, SelectOption } = dropdowns;
const { HorizontalBox, BoxText } = layouts;

const options = [
    { key: 'basic', text: 'Filename searching', selected: true },
    { key: 'advanced', text: 'Advanced searching', selected: false }
];

const DropDownIconButton = props => {
    const { setSelectedItem } = props;

    const onChange = item => {
        setSelectedItem(item.key);

        options.forEach(op => {
            op.selected = false;
            if (op.key === item.key) {
                op.selected = true;
            }
        });
    };

    const valueItemGenerator = (opt, index) => (
        <SelectOption key={`${opt.key}_${index}_${guid()}`} value={opt} title={opt.key}>
            <HorizontalBox>
                <switches.Radio checked={opt.selected} readOnly />
                <BoxText>{opt.text}</BoxText>
            </HorizontalBox>
        </SelectOption>
    );

    const selectOptions = options.map((opt, index) => valueItemGenerator(opt, index));

    return (
        <DropDownIconButtonWrapper>
            <CustomSelect
                multiple={false}
                paddedMenu={false}
                shortenText={true}
                size="large"
                appearance="secondary"
                optionsTextSize="small"
                onChange={onChange}
            >
                {selectOptions}
            </CustomSelect>
        </DropDownIconButtonWrapper>
    );
};

export default DropDownIconButton;
